import React, { useMemo } from "react";
import { twMerge } from "tailwind-merge";
import DOMPurify from "dompurify";
import styles from "./MarkdownText.module.scss";
import snarkdown from "./snarkdown/snarkdown";
const MarkdownText = ({ children, className, onlyLinks, image, }) => {
    let html = useMemo(() => {
        const text = replaceUnderscoresInVariables(children);
        let result = DOMPurify.sanitize((onlyLinks ? replaceLinks : snarkdown)(text), {
            USE_PROFILES: { html: true },
        }).replace(/<a\s+(?:[^>]*?\s+)?href=(["'])(.*?)\1(?:[^>]*?\s+)?>(.*?)<\/a>/gi, `<a target="_blank" rel='noreferrer noopener' href="$2">$3</a>`);
        if (image && !onlyLinks) {
            result = DOMPurify.sanitize(snarkdown(`![Image](${image.url})`)) + result;
        }
        return restoreUnderscoresInVariables(result);
    }, [children, onlyLinks, image?.url]);
    // Remove new lines after list tags. This is necessary to prevent extra spacing in the rendered text since we are using pre-wrap
    html = html.replace(/((ol|ul)>)(\r?\n)/g, "$1");
    return (React.createElement("div", { style: { wordBreak: "break-word" }, className: twMerge("whitespace-pre-wrap", styles.root, className, image &&
            "[&>img]:float-left [&>img]:mr-3 [&>img]:mt-1 [&>img]:!h-[112px] [&>img]:w-[112px] [&>img]:rounded-[10px]"), dangerouslySetInnerHTML: {
            __html: html,
        } }));
};
export default MarkdownText;
// snarkdown threats underscore as italic, so we need to replace it with % before processing
const replaceUnderscoresInVariables = (text) => {
    return text.replace(/{(.*?)}/g, (match) => match.replace(/_/g, "%"));
};
const restoreUnderscoresInVariables = (text) => {
    return text.replace(/{(.*?)}/g, (match) => match.replace(/%/g, "_"));
};
const replaceLinks = (text) => text.replace(/(\[([^\]]+)\]\(([^)]+)\))/g, "<a href='$3'>$2</a>");
//# sourceMappingURL=MarkdownText.js.map